<script>
    import {_} from '../lib/i18n';
    import {Constans} from "../lib/Constants";

    export let params;
    export let analyze;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    import {navigate} from "svelte-routing";
    import {calcTimeByOffset, parseDateFromString} from "../lib/Common.svelte";

    let lastRevisionDate;
    $: lastRevisionDate = analyze ? parseDateFromString(analyze.feedsLastUpdateDate) : calcTimeByOffset(Constans.timeZoneOffset);

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }


</script>

<section class="feed-update-block tail">
    <h2 class="feed-update-block__title tail__title">{$_('freeAccessUnlockDataAlert.title')}</h2>
    <p class="feed- update-block__text tail__text" style="margin-bottom: 25px">
        {$_('freeAccessUnlockDataAlert.lastRefreshDate')}: {String(lastRevisionDate.getDate()).padStart(2, '0')}.{String(lastRevisionDate.getMonth() + 1).padStart(2, '0')}.{lastRevisionDate.getFullYear()} {String(lastRevisionDate.getHours()).padStart(2, '0')}:{String(lastRevisionDate.getMinutes()).padStart(2, '0')}
    </p>
    <button class="button button_icon-text button_gradient button_shadow"
            on:click={gotoTariffs}>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.55569 10.0907L1.86165 10.375L2.55569 10.0907ZM3.24974 9.19352C4.25794 6.73184 6.67713 5 9.49902 5V3.5C6.04742 3.5 3.09261 5.61944 1.86165 8.62501L3.24974 9.19352ZM9.49902 5C12.3209 5 14.7401 6.73185 15.7483 9.19352L17.1364 8.62502C15.9054 5.61944 12.9506 3.5 9.49902 3.5V5ZM15.7483 9.80648C14.7401 12.2682 12.3209 14 9.49902 14V15.5C12.9506 15.5 15.9054 13.3806 17.1364 10.375L15.7483 9.80648ZM9.49902 14C6.67713 14 4.25794 12.2682 3.24974 9.80648L1.86165 10.375C3.09261 13.3806 6.04742 15.5 9.49902 15.5V14ZM15.7483 9.19352C15.8287 9.38978 15.8287 9.61022 15.7483 9.80648L17.1364 10.375C17.366 9.81441 17.366 9.1856 17.1364 8.62502L15.7483 9.19352ZM1.86165 8.62501C1.63206 9.18559 1.63206 9.81441 1.86165 10.375L3.24974 9.80648C3.16936 9.61022 3.16936 9.38978 3.24974 9.19352L1.86165 8.62501Z" fill="white"/>
                <circle cx="9.5" cy="9.5" r="2.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        <span>{$_('freeAccessUnlockDataAlert.unlockDataBtnLabel')}</span>
    </button>
</section>

<style>

</style>